'use strict'
// Charge les différents modules pour la vue correspondante.

import master from 'Modules/master'
import ShowHide from 'Modules/showHide'
import showAlerte from 'Modules/showAlerte'
import addToBarketVerification from 'Modules/addToBarketVerification'
import carousel from 'Modules/carousel'
import { ManageItemInWishlist } from 'Modules/wishList'
import inscriptionModule from 'Modules/inscriptionModule'
import profileCookie from 'Modules/profileCookie'
import lazyloadimgencarts from 'Modules/lazyLoadingImage'
import modal from 'Modules/modal'
import { PopIn3M } from 'Modules/fusion3m'
import { CRO } from 'Modules/cro'

const description = new ShowHide(J_SELECTED, '', '_desc')
description.setEvents()
showAlerte.setEventProduit()
showAlerte.setEventProduitMob()
showAlerte.setEventProduitNoSize()
addToBarketVerification.setEvent()
lazyloadimgencarts.setEvent()
carousel.activerCarrouselProduitsSimilaires()
carousel.activerCarrouselProduitMobile()
master.process()
inscriptionModule.Process()
import('Modules/produit').then((produit) => {
    produit.default.setEvent('.j_buy-express')
})

const J_SELECTED = 'selected'
const J_SHOW_SIM_VISUEL_CTA = document.querySelector('.j_show_sim_visuel_cta')
const J_SHOW_SIM_CARACT_CTA = document.querySelector('.j_show_sim_caract_cta')
let isLoadTxtMS = false

// Récupération du guide de taille lors du click sur le bouton "Guide des tailles"
$('.j-guide-taille').click(function () {
    const codegenre = $('.j-genre').val()
    const refMarque = $('.j-marque').val()
    const url =
        window.location.origin +
        '/produit/ModalGuideTaille?codegenre=' +
        codegenre +
        '&refMarque=' +
        refMarque

    modal.creer(
        'modalGuideTaille',
        'm-guide-taille slide-in-pop-in',
        url,
        function () {
            $('body').mouseup(function (e) {
                const subject = $('#modalGuideTaille')

                if (
                    e.target.id != subject.attr('id') &&
                    !subject.has(e.target).length
                ) {
                    subject.modal('hide')
                }
            })
        }
    )
})

// MOBILE :  Gère le click sur l'icone coeur (Ajout à la wishlist)
$('.wishListItem').click(function () {
    const codetaille = $("select[name='ct']").val()

    const item = $(this)

    if (
        $("select[name='ct'] option:selected").hasClass('j_tDispo_showAlerte')
    ) {
        ManageItemInWishlist(item, codetaille)
    }
})

// Gère le retour en arrière dans le navigateur
$('.return-link, .return-link-pdt').on('click', function (e) {
    if (this.href == 'javascript:void(0)') {
        e.preventDefault()
        history.go(-1)
    }
})

// Gère l'ajout à la wishlist pour les produits similaires
$('.wishListItem-sim').click(function () {
    const item = $(this)

    ManageItemInWishlist(item, null)
})

// Lazyload img produit similaire
$(document).scroll(function () {
    const imgArray = document.querySelectorAll('.lazyload-pdt')

    for (let i = 0; i < imgArray.length; i++) {
        const img = imgArray[i]

        if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src')
            img.removeAttribute('data-src')
        }
    }
})

// Affiche la liste des tailles disponibles
$('.productListTailles').on('click', '.j_choix_tailles', function () {
    $('.j_box_tailles').addClass('active')
    $('body').css('overflow', 'hidden')
})

// Validation de la taille sélectionnée
$('.productListTailles').on('click', '.j_tDispo_choix', function () {
    $('.j_tDispo_choix').removeClass('selected')
    $('.j_box_tailles').removeClass('active')
    $('j_alerte_showAlerte option').each(function () {
        if ($(this).isChecked()) {
            $(this).removeProp('selected')
            $('.j_tDispo_choix').removeClass('selected')
        }
    })

    $('.j_alerte_showAlerte option[value="' + $(this).attr('id') + '"]').prop(
        'selected',
        true
    )
    const id = '#' + $(this).attr('id')
    $('.j_choix_tailles p > span:first')
        .empty()
        .append($('.choix-tailles ' + id + ' .taillefr').text())
    $('.j_choix_tailles.mob p > span:first')
        .empty()
        .append(
            $('.choix-taillesmob ' + id + ' .taillefr').text() +
                " <b class='chevron'></b>"
        )
    $(id).addClass('selected')
    $('body').css('overflow', 'auto')
    if ($(this).parents('.choix-tailles').length > 0) {
        $('.j_choix_tailles span').removeAttr('id')
    }
    // Si on a cliqué sur le bouton ajout panier pour afficher les listes des tailles, on fait la mise au panier lors du choix de la taille
    if (
        ($(this).parents('.choix-taillesmob').length > 0 &&
            $('.choix-taillesmob').hasClass('autobasket')) ||
        ($(this).parents('.choix-tailles').length > 0 &&
            $('.choix-tailles').hasClass('autobasket'))
    ) {
        $('.j_addToBarket_addToBarketVerification').trigger('click')
    }
})

// Affichage overlay tailles
$('.overlay-tailles').click(function () {
    $('.j_box_tailles').removeClass('active')
    $('body').css('overflow', 'auto')
})

// Ferme tailles
$('.close-taille').click(function () {
    $('.j_box_tailles').removeClass('active')
    $('body').css('overflow', 'auto')
})

// Accordeon (Description / Matières et entretien / Livraison / Paiement / Retour)
$('.j-accordeon').click(function () {
    const lien = $(this).attr('data-target')
    const tab = lien.substring(1, lien.length)

    if (
        !$(this).hasClass('loaded') &&
        tab != 'description' &&
        tab != 'matieres' &&
        tab != 'conseildestyle'
    ) {
        $(this).addClass('loaded')

        const url = window.location.origin + '/produit/TabsAjax?tab=' + tab

        $.get(url, function (data) {
            $('#' + tab)
                .children('.panel-body')
                .html(data)
        })
    }
})

// Filtres produits similaires
if (document.getElementsByClassName('j_show_sim_visuel_cta').length > 0) {
    J_SHOW_SIM_VISUEL_CTA.addEventListener('click', function (event) {
        J_SHOW_SIM_VISUEL_CTA.classList.add('active')
        J_SHOW_SIM_CARACT_CTA.classList.remove('active')
        if (document.getElementsByClassName('pdts_photo').length > 0) {
            document.querySelector('.pdts_photo').style.display = 'block'
        }
        if (document.getElementsByClassName('pdts_description').length > 0) {
            document.querySelector('.pdts_description').style.display = 'none'
        }
    })
}

if (document.getElementsByClassName('j_show_sim_caract_cta').length > 0) {
    J_SHOW_SIM_CARACT_CTA.addEventListener('click', function (event) {
        J_SHOW_SIM_VISUEL_CTA.classList.remove('active')
        J_SHOW_SIM_CARACT_CTA.classList.add('active')
        if (document.getElementsByClassName('pdts_photo').length > 0) {
            document.querySelector('.pdts_photo').style.display = 'none'
        }
        if (document.getElementsByClassName('pdts_description').length > 0) {
            document.querySelector('.pdts_description').style.display = 'block'
        }
    })
}

/* Animation slider produits similaires */
$('.j_next_sim').on('click', function (e) {
    $(this).siblings('.j_custom_slide').animate({ scrollLeft: '+=358' }, 800)
})

$('.j_prev_sim').on('click', function (e) {
    $(this).siblings('.j_custom_slide').animate({ scrollLeft: '-=358' }, 800)
})

$('.j_car_mob').scrollLeft('80')

$('.j_next_photo').on('click', function (e) {
    $(this)
        .siblings('.j_slidePhoto_vertical')
        .animate({ scrollTop: '+=200' }, 800)
})

$('.j_prev_photo').on('click', function (e) {
    $(this)
        .siblings('.j_slidePhoto_vertical')
        .animate({ scrollTop: '-=200' }, 800)
})

$('.prodsim .containCaract').each(function (index) {
    if ($(this).children('.prodsim__caracteristique').length == 0) {
        $(this).addClass('containCaract--void')
        $(this)
            .parents('.prodsim')
            .find('.prodsim__listeTailles')
            .addClass('prodsim__listeTailles--bigMobile')
    }
    if ($(this).children('.prodsim__caracteristique').length > 0) {
        $(this)
            .parents('.prodsim')
            .find('.prodsim__infos')
            .addClass('prodsim__infos--bigDesktop')
    }
})

/**
 * MAISON SECONDE
 */

// Récupère le texte de description au scroll
window.addEventListener('scroll', function (e) {
    if (isLoadTxtMS == false) {
        isLoadTxtMS = true
        $.ajax({
            url: '/Produit/TexteSecondeMainAjax',
            dataType: 'html',
            type: 'post',
            success: function (responseHtml) {
                $('#j_loadTexteMSAjax').html(responseHtml)
            }
        })
    }
})

// Modale "Etats de nos articles de seconde main"
if (document.getElementById('j_infosSecondeMain')) {
    document
        .getElementById('j_infosSecondeMain')
        .addEventListener('click', function () {
            const url = window.location.origin + '/produit/ModalSecondeMain'

            modal.creer('modalSecondeMain', 'm-SecondeMain', url, function () {
                $('body').mouseup(function (e) {
                    const subject = $('#modalSecondeMain')

                    if (
                        e.target.id != subject.attr('id') &&
                        !subject.has(e.target).length
                    ) {
                        subject.modal('hide')
                    }
                })
            })
        })
}

/*=============== collapse SEO ======================= */
const btnp2 = document.getElementById('btnVoirPlusDesc')
const wrapper2 = document.getElementById('expanVoirPlusDesc')

function collapse(button, container) {
    if (button == undefined) {
        return
    }
    button.addEventListener('click', clickVoirPlus)
    button.addEventListener('touchend', clickVoirPlus)
}

function collapseEvent(button, container) {
    container.classList.toggle('active')
    if (container.classList.contains('active')) {
        button.innerHTML = 'Voir moins'
    } else {
        button.innerHTML = 'Voir plus'
    }
}

function clickVoirPlus(e) {
    collapseEvent(btnp2, wrapper2)
    e.preventDefault()
}

collapse(btnp2, wrapper2)

/*=========================================== */

// Cache le volet des tailles
$('.ctaPopInProduit').on('click', () => {
    $('.j_box_tailles').removeClass('active')
})

/**
 * POP IN 3M
 */
const GENRE = $('.ctaPopInProduit').data('genre')
const SHOW_TEXT = $('.ctaPopInProduit').data('show') === 'True'
const TEXT_CTA_POP_IN = '.text-3m-produit'

const profiles = profileCookie.getProfiles()

// Cache le texte du cta pour la pop in si le client a déjà des tailles de définies pour le genre
if (
    (profiles[GENRE] != null &&
        Object.keys(profiles[GENRE].sizes).length !== 0) ||
    !SHOW_TEXT
) {
    $(TEXT_CTA_POP_IN).hide()
}

// Ajoute le genre à la modale
$('#modal-fusion3m-produit').attr('data-genre', GENRE)

new PopIn3M('#modal-fusion3m-produit')
    .setEvent('click')
    .setEventElement('.ctaPopInProduit')
    .setIsOpenAuto(true)
    .setShowStyleOptions(false)
    .setContainerClass('jsModalFusion3mProduit')
    .setRedirectUrl(
        `${window.location.origin}/modzlab${window.location.pathname}`
    )
    .build()

/**
 * Modal CRO
 */

if ($('.cro').data('cro') === 1) {
    new CRO().init()
}

/**
 * Magic zoom LCP fix
 */

let mzRetry = 0

function initMagicZoom(event) {
    // premiere initialisation OnClick de MagicZoom
    if (!event.target.classList.contains('MagicZoom')) {
        window.mzclick = true
        event.preventDefault()
        $(event.target).closest('.ModzMagicZoom').addClass('MagicZoom')
        executeMagicZoomWhenReady()
    }
}

function executeMagicZoomWhenReady() {
    if (!window.MagicZoom && typeof window.MagicZoom.start !== 'function') {
        setTimeout(executeMagicZoomWhenReady, 100)
        return
    }

    try {
        window.MagicZoom.start()
    } catch (error) {
        if (mzRetry < 10) {
            mzRetry++
            setTimeout(executeMagicZoomWhenReady, 10)
        } else {
            console.error('Erreur de chargement de MagicZoom, Abandon')
        }
    }
}

$('.ModzMagicZoom').on('click', initMagicZoom)
